module.exports = __webpack_public_path__ + "img/icons-success.08aa8335.svg";